import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M280-227q-105 0-179-74T27-480q0-106 74-179 74-74 179-74h400q105 0 179 74t74 179q0 106-74 179-74 74-179 74H280Zm0-73h400q75 0 128-52t52-128q0-75-52-127t-128-53H280q-75 0-127 53t-53 127q0 75 53 128t127 52Zm-1-79q42 0 72-29t29-72q0-42-29-71t-72-30q-42 0-71 29t-30 72q0 42 29 72t72 29Zm201-101Z"/>',
  f: '<path d="M280-227q-105 0-179-74T27-480q0-106 74-179 74-74 179-74h400q105 0 179 74t74 179q0 106-74 179-74 74-179 74H280Zm-1-152q42 0 72-29t29-72q0-42-29-71t-72-30q-42 0-71 29t-30 72q0 42 29 72t72 29Z"/>',
};

export default data;
